<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import autofit from "autofit.js";
import "./assets/font.css";
import "./utils/basics.less";

export default {
  name: "app",
  components: {},
  data() {
    return {};
  },
  mounted() {
    autofit.init({
      dh: 1080,
      dw: 1920,
      el: "body",
      resize: true,
    }, true);
  },
  created() {
  },
};
</script>

<style lang='less'>
::-webkit-scrollbar {
  display: none;
}

#app {
  width: 100%;
  height: 100%;
  overflow: auto;
}
</style>
